import { LeftSidebarContext } from '@hooks/sidebar/useLeftSidebar';
import { Box, useMantineTheme } from '@mantine/core';
import { type FC, type PropsWithChildren } from 'react';
import { LEFT_SIDEBAR_COLLAPSED_WIDTH, LEFT_SIDEBAR_WIDTH } from './constants';

type Props = {
    isOpen: boolean;
    onToggle: () => void;
    /** Expanded width. The 250px default fits the operator nav; a shorter menu can sit tighter. */
    width?: number;
};

export const LeftSidebar: FC<PropsWithChildren<Props>> = ({
    isOpen,
    onToggle,
    width,
    children,
}) => {
    const theme = useMantineTheme();

    return (
        <LeftSidebarContext.Provider value={{ isOpen, toggle: onToggle }}>
            <Box
                component="aside"
                style={{
                    width: isOpen
                        ? (width ?? LEFT_SIDEBAR_WIDTH)
                        : LEFT_SIDEBAR_COLLAPSED_WIDTH,
                    height: '100vh',
                    backgroundColor: theme.colors.gray[0],
                    borderRight: `1px solid ${theme.colors.gray[3]}`,
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'width 0.2s ease',
                    boxSizing: 'border-box',
                }}
            >
                {children}
            </Box>
        </LeftSidebarContext.Provider>
    );
};
